export /**
 *
 *
 * @param {string} role
 * @return {string} route to navigate to
 */
const findPostLoginRoute = (role) => {
  switch (role) {
    case "SUPERADMIN":
      return "/admin";
    case "DISTRIBUTOR":
      return "/admin";
    case "CUSTOMER":
      return "/login/apps";
    default:
      return "/login/apps";
  }
};
